module.exports = __webpack_public_path__ + "img/sport.d881599b.png";